const animationSpeed = 500; // Animation duration in milliseconds



function toggleMobileMenu(el, close) {
  const inner =  el.querySelector('#mobile-menu-inner');
  const submenu = el.querySelector('#submenu');
  if (close || el.classList.contains('translate-x-0')) {
    submenu.classList.add('hidden');
    inner.classList.add('-right-full');
    inner.classList.remove('right-0');
    setTimeout(() => {
      el.classList.add('translate-x-full');
      el.classList.remove('translate-x-0');
    }, animationSpeed); // Animation duration (same as transition on inner element)
  } else if (!close) {
    el.classList.add('translate-x-0');
    el.classList.remove('translate-x-full');
    inner.classList.add('right-0');
    inner.classList.remove('-right-full');
    setTimeout(() => {
      submenu.classList.remove('hidden');
    }, animationSpeed); // Animation duration (same as transition on inner element)
  }
}


document.addEventListener('DOMContentLoaded', () => {
  const hamburgerBtn = document.getElementById('hamburger-btn');
  const mobileMenu = document.getElementById('mobile-menu');
  const menuOverlay = document.getElementById('menu-overlay');
  const closeMenu = document.getElementById('close-menu');
  const submenuButtons = document.querySelectorAll('.submenu-btn');
  const submenu = document.getElementById('submenu');
  const submenuContent = document.getElementById('submenu-content');

  if (hamburgerBtn && mobileMenu) {
    hamburgerBtn.addEventListener('click', () => {
      toggleMobileMenu(mobileMenu);
    });
  }

  if (closeMenu && mobileMenu && submenu) {
    closeMenu.addEventListener('click', () => {
      toggleMobileMenu(mobileMenu, true);
      toggleSubmenu(submenu, true);
    });

    menuOverlay.addEventListener('click', () => {
      toggleMobileMenu(mobileMenu, true);
      toggleSubmenu(submenu, true);
    });
  }

  // Close mobile menu when a menu item is clicked
  const menuItems = mobileMenu.querySelectorAll('li');
  menuItems.forEach(item => {
    item.addEventListener('click', () => {
      toggleMobileMenu(mobileMenu, true);
    });
  });

  const nav = document.getElementById('main-navigation');
  const hasHero = nav.getAttribute('data-has-hero') === 'true';
  const isBlackNav = document.body.classList.contains('nav-black');
  const hero = document.querySelector('.hero');
  let lastScroll = 0;
  let isScrolling = false;
  const scrollThreshold = 50; // Distance in pixels before hiding the nav

  function toggleSubmenuList(el) {
    const isOpen = !el.classList.contains('hidden');
      
    // If the element is open, close it
    if (isOpen) {
      el.style.maxHeight = '0';  // Set max-height to 0 for closing animation
      el.classList.remove('opacity-100');
      el.classList.add('opacity-0');
      
      // After the animation, hide the element with `hidden`
      setTimeout(() => {
        el.classList.add('hidden');
      }, animationSpeed); // Animation duration (same as transition on submenuList element)
      
    } else {
      // If the element is closed, first remove `hidden`
      el.classList.remove('hidden');
      el.style.maxHeight = '0';  // First set max-height to 0 to trigger animation
  
      // Calculate the actual height of the content
      const contentHeight = el.scrollHeight;
  
      // Add transition to max-height, but without moving the link
      el.style.transition = 'max-height 0.5s ease-in-out, opacity 0.5s ease-in-out';
  
      // Set a large enough max-height for dynamic content, allowing animation to work
      el.style.maxHeight = `${contentHeight}px`;
      el.classList.add('opacity-100');  // Increase opacity
    }
  }

  if (nav) {
    if (isBlackNav) {
      nav.classList.add('nav-transparent-dark');
      nav.classList.remove('nav-transparent', 'nav-white');
    } else {
      nav.classList.add('nav-transparent');
      nav.classList.remove('nav-transparent-dark', 'nav-white');
    }
  }

  window.addEventListener('scroll', handleScroll, { passive: true });

  function handleScroll() {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

    if (Math.abs(currentScroll - lastScroll) > scrollThreshold) {
      if (currentScroll > lastScroll) {
        // Scrolling down
        nav.classList.add('nav-hidden');
        nav.classList.remove('nav-visible');
      } else {
        // Scrolling up
        nav.classList.add('nav-visible');
        nav.classList.remove('nav-hidden');
      }

      lastScroll = currentScroll <= 0 ? 0 : currentScroll; // For Mobile or negative scrolling
    }
  }

  if (nav) {
    window.addEventListener('scroll', handleScroll, { passive: true });
  }
});


// Add CSS classes for fade-in and fade-out effects
const style = document.createElement('style');
style.innerHTML = `
  .nav-hidden {
    opacity: 0;
    transition: opacity 0.5s ease-in-out;
  }
  .nav-visible {
    opacity: 1;
    transition: opacity 0.5s ease-in-out;
  }
  /* Ensure menu item retains its color when clicked */
  #mobile-menu li:active, #mobile-menu li:focus {
    color: inherit;
  }
`;
document.head.appendChild(style);